$('.single-item').slick({
  dots: true,
  arrows: false,
});
